import {  AfterViewInit, Component, OnDestroy, OnInit, Input } from '@angular/core';
import { CommonService } from '../../services/common.service';
import { FilterType } from '../../models/filter-type';
import { AemService } from 'abs-ngx-library/src/lib/core';
/** 
 * Expected values for dealsCarousel
   urlPageName used as API path = deals-carousel
   pageName used as data attribute in HTML = dealsSponsoredCarousel

   * Expected values for discoveryCarousel
   urlPageName used as API path = dealsdiscovery-carousel
   pageName used as data attribute in HTML = dealsdiscoveryCarousel
*/
@Component({
  selector: 'app-sponsored-carousel-wrapper',
  templateUrl: './sponsored-carousel-wrapper.component.html',
  styleUrls: ['./sponsored-carousel-wrapper.component.scss']
})
export class SponsoredCarouselWrapperComponent implements OnInit, OnDestroy, AfterViewInit {

  @Input() carouselData: any;
  @Input() pageName: string = '';
  @Input() urlPageName: string = '';
  
  private initTimeout: ReturnType<typeof setTimeout> | null = null;
  
  constructor(
    private commonService: CommonService,
    private absAemService: AemService
  ) {}
  public filterSubscription:any;
  public sponsoredCarouselAPIPath:any;
  public carouselUsers: string = 'false';
  public _window:any = window;
  private resizePoll: ReturnType<typeof setInterval> | null = null;

  ngOnInit(): void {
    const searchConfig = this._window['SWY'].CONFIGSERVICE.searchConfig?.['apimSearchPath'];
    const endpoint = this._window['SWY'].CONFIGSERVICE.searchConfig?.['apimSearchSponsoredCarouselEndpoint'];
    const emsmSponsoredEndpoint = this._window['SWY'].CONFIGSERVICE.searchConfig?.['apimEmsmSponsoredCarouselEndpoint'];
    const isEMSMSponsoredDealsDisabled = this.absAemService.getFeatureFlagByNameDisable('isEMSMSponsoredDealsDisabled')
    this.carouselUsers = !isEMSMSponsoredDealsDisabled ? 'R' : 'false';
    const baseUrl = !isEMSMSponsoredDealsDisabled ? emsmSponsoredEndpoint : searchConfig + endpoint;
    this.sponsoredCarouselAPIPath = baseUrl + `?storeid={storeId}&screenWidth={screenWidth}&userid={userId}&banner={banner}&pagename=${this.urlPageName}&featuredsessionid={featuredSessionId}`;
    this.filterSubscription = this.commonService._selectedFiltersRefresh.subscribe((filters: FilterType[])=>{
      const filterQuery = this.commonService['constructFilterQueries'](filters)
      this._window['appConfigServiceRef'].service._updateSearchCrossSell.next(filterQuery)
      this._dispatchResizeOnceRendered();
    })
  }
  ngAfterViewInit(){
    if (this.commonService.sponsoredCarouselInitialised) {
      return;
    }

    if (this._window['appConfigServiceRef'] !== undefined) {
       this.initSponsoredCarousel();
    } else {
       this.initTimeout = setTimeout(() => { this.initSponsoredCarousel(); }, 1000);
    }
  }

  initSponsoredCarousel(){
    if (this._window['appConfigServiceRef'] !== undefined && !this.commonService.sponsoredCarouselInitialised) {
      this.commonService.sponsoredCarouselInitialised = true;
      this._window['appConfigServiceRef'].zone.run(() => {
        this._window['appConfigServiceRef'].service.initLazyWrapper();
        this._window['appConfigServiceRef'].service.initServiceCall();
      });
    } else {
        console.warn('All Deals - sponsored-carousel - appConfigServiceRef is still undefined...');
    }
  }
  
  ngOnDestroy(): void {
    if (this.filterSubscription) {
      this.filterSubscription.unsubscribe();
      this.filterSubscription = null;
    }
    if (this.initTimeout) {
      clearTimeout(this.initTimeout);
      this.initTimeout = null;
    }
    if (this.resizePoll) {
      clearInterval(this.resizePoll);
      this.resizePoll = null;
    }
  }

  private _dispatchResizeOnceRendered(): void {

    const dispatchResize = () => {
        window.dispatchEvent(new Event('resize'));
      }

    const startResizePoll = () => {
      const POLL_INTERVAL = 1000;
      const POLL_DURATION = 5000;
      const endTime = Date.now() + POLL_DURATION;
      dispatchResize(); // Fire immediately on detection, don't wait for first interval
      this.resizePoll = setInterval(() => {
        dispatchResize();
        if (Date.now() >= endTime) {
          clearInterval(this.resizePoll!);
          this.resizePoll = null;
        }
      }, POLL_INTERVAL);
    };

    // Already rendered — start polling immediately
    if (document.querySelector('app-sponsored-carousel-wrapper quantity-stepper-al-v2')) {
      startResizePoll();
      return;
    }

    // Wait for element to appear, then start polling
    const observer = new MutationObserver(() => {
      if (document.querySelector('app-sponsored-carousel-wrapper quantity-stepper-al-v2')) {
        observer.disconnect();
        startResizePoll();
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });

    setTimeout(() => {
      observer.disconnect();
    }, 5000);
  }
}
